export default __webpack_public_path__ + "static/media/hrgless.e71540a5.jpg";